import * as React from 'react';

import useRouter, { useParams } from 'js/lib/useRouter';

import ProgramHomeDomainSubdomainContainer from 'bundles/enterprise-collections/components/ProgramHomeDomainSubdomainContainer';
import type { Product, ProductType } from 'bundles/enterprise-legacy-learner-home/types/programCommon';
import { getProductPath, redirectToUnifiedDescriptionPage } from 'bundles/enterprise-legacy-xdp/hocs/withMiniModal';
import {
  useIsC4cv,
  useIsUpswell,
  useIsWESContract,
  useProgram,
} from 'bundles/unified-common/contexts/EnterpriseProgramContext';
import { useThirdPartyOrganization } from 'bundles/unified-common/contexts/ThirdPartyOrganizationContext';

const EnterpriseBrowseDomainRootContent = () => {
  const router = useRouter();
  const program = useProgram();
  const thirdPartyOrg = useThirdPartyOrganization();
  const isC4cv = useIsC4cv();
  const isUpswell = useIsUpswell();
  const isWESContract = useIsWESContract();
  const params = useParams();

  if (!program || !thirdPartyOrg) {
    return null;
  }

  function onProductCardClick(product: Product, productType: ProductType, collectionId?: string | null) {
    if (productType === 'clip') {
      window.open(`/videos/${product.slug}?program=${program?.metadata?.slug}`, '_blank');
    } else {
      redirectToUnifiedDescriptionPage(
        router,
        {
          slug: product.slug,
          productPagePath: getProductPath(product),
        },
        collectionId || undefined,
        router.location.query
      );
    }
  }

  return (
    <ProgramHomeDomainSubdomainContainer
      programId={program.id}
      domainSlug={params.domainSlug}
      subdomainSlug={params.subdomainSlug}
      programSlug={program.metadata?.slug}
      thirdPartyOrganizationId={thirdPartyOrg.id}
      onProductCardClick={onProductCardClick}
      isWESContract={!!isWESContract}
      isC4cv={!!isC4cv}
      isUpswell={!!isUpswell}
      program={program}
      thirdPartyOrgSlug={thirdPartyOrg.slug}
      programName={program.metadata?.name}
    />
  );
};

export default EnterpriseBrowseDomainRootContent;
